// GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html,
  body,
  #root {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background: #0D0E14;
    color: #fff;
    font-family: 'Inter', 'Roboto', -apple-system, sans-serif;
    -webkit-font-smoothing: antialiased;
  }
`;
